export default function apostrophe(name?: string | null) {
  if (!name) {
    return "";
  } else if (/s$/i.test(name)) {
    return `${name}'`;
  } else {
    return `${name}'s`;
  }
}
